/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const BundleBuilderFragment = {
  BundleBuilder: gql`
    fragment BundleBuilderQuery on bundleBuilder_Entry {
      componentTitle
      styles
      builderCategory {
        ... on bundleBuilderCategory_Category {
          productCouponOverride
          bundleBuildCards {
            ... on bundleBuildEntry_Entry {
              baseProductPrio
              baseProducts {
                deliveryType
                productId
              }
              electiveProducts {
                productId
              }
              entryState
              minHours
              requiredProducts {
                multipleRegulators
                productId
              }
              showMoreInfo
              moreInfo
            }
          }
        }
      }
      cartCtaLabel
      deliveryMethodLabel
      dropDownLabel
      hideScheduleCta
      formTitle
      productListTitle
      stateRequirementsTitle
      recommendedProductContent
      electiveTitle
      typeHandle
    }
  `,
};
